import "../Component3/css/Termcondition.css";
import SEO from "../SEO";
import { seoConfig } from "../config/seoConfig";
import logo from "../Component2/logo/hirelink.png";

function Termscondition() {
  return (
    <>
      <SEO
        title={seoConfig.e_term.title}
        description={seoConfig.e_term.description}
      />
      <div className="ect-body">
        <div
          className="ect-wrapper"
          style={{ backgroundImage: `url(${logo})` }}
        >
          <div className="ect-container">
            <h2 className="ect-title">Employer Return & Refund Policy</h2>
            <h6
              className=""
              style={{ textAlign: "center", fontWeight: "bold" }}
            >
              PharmaJobsHireLink – Official Pharma Job Portal Policy
            </h6>

            <h3 className="ect-heading">1. Platform Purpose</h3>
            <p className="ect-text">
              PharmaJobsHireLink is a professional <b>pharma job portal</b>{" "}
              designed to connect verified pharmaceutical employers with
              qualified candidates seeking jobs in QA, QC, Production, R&D,
              Regulatory Affairs, Packaging, Sales, Clinical Research, and other
              pharma sectors.
            </p>

            <p className="ect-text">
              The platform serves strictly as a <b>technology interface</b> that
              enables employers to search, filter, and connect with candidates.
              We do not act as a recruitment agency, hiring consultant, or
              employment guarantor.
            </p>

            <p className="ect-text">
              By registering or using this job portal, employers agree to comply
              fully with these Terms & Conditions.
            </p>

            <h3 className="ect-heading">
              2. Employer Registration & Account Eligibility
            </h3>
            <p className="ect-text">
              To access employer features, organizations must:
            </p>
            <p className="ect-text">
              ● Be a legitimate pharmaceutical company, staffing agency, or
              authorized recruiter<br></br>● Provide accurate company details
              <br></br>● Use official company email addresses for registration
              <br></br>● Maintain updated business information
            </p>
            <p className="ect-text">
              The platform reserves the right to verify employer credentials
              before activating accounts.
            </p>

            <h3 className="ect-heading">
              3. Employer Signup Fees (Strictly Non-Refundable)
            </h3>
            <p className="ect-text">The following charges apply:</p>
            <table class="tblx9-wrapper">
              <thead class="tblx9-head">
                <tr class="tblx9-row">
                  <th class="tblx9-th">Service</th>
                  <th class="tblx9-th">Fee</th>
                  <th class="tblx9-th">GST</th>
                  <th class="tblx9-th">Total</th>
                </tr>
              </thead>

              <tbody class="tblx9-body">
                <tr class="tblx9-row">
                  <td class="tblx9-td">Employer Registration</td>
                  <td class="tblx9-td">₹5000</td>
                  <td class="tblx9-td">18%</td>
                  <td class="tblx9-td">As applicable</td>
                </tr>

                <tr class="tblx9-row">
                  <td class="tblx9-td">Staff Sub-Account Creation</td>
                  <td class="tblx9-td">₹2500</td>
                  <td class="tblx9-td">18%</td>
                  <td class="tblx9-td">As applicable</td>
                </tr>

                <tr className="tblx9-row">
                  <td class="tblx9-td">Resume Download (Per Candidate)</td>
                  <td class="tblx9-td">₹60</td>
                  <td class="tblx9-td">18%</td>
                  <td class="tblx9-td">As applicable</td>
                </tr>
              </tbody>
            </table>

            <h3 className="ect-heading">Important Payment Conditions</h3>
            <p className="ect-text">
              ● All fees are <b>100% advance</b>
              <br></br>● All payments are <b>strictly non-refundable</b>
              <br></br>● GST once paid cannot be reversed
              <br></br>● Payment does not guarantee hiring success
            </p>

            <p className="ect-text">
              Fees are charged solely for{" "}
              <b>
                platform access, resume visibility, and candidate search
                features
              </b>{" "}
              within the pharma job portal.
            </p>

            <h3 className="ect-heading">4. Employer Staff Access</h3>
            <p className="ect-text">
              Registered employers may create staff logins for internal HR
              teams.
            </p>
            <p className="ect-text">
              ● Each staff login requires payment of ₹2500 + GST<br></br> ●
              Staff accounts must be used only by authorized employees <br></br>
              ● Login sharing is strictly prohibited<br></br> ● Employers are
              fully responsible for actions performed through staff accounts
              <br></br>
              <br></br>Violation may result in suspension of all associated
              accounts.
            </p>

            <p className="ect-text">
              Each resume download costs <b>₹60 + 18% GST</b> and is{" "}
              <b>non-refundable,</b>
              regardless of hiring outcome.
            </p>

            <p className="ect-text">
              Downloaded resumes must be used{" "}
              <b>only for recruitment purposes</b> and not for:
            </p>
            <p className="ect-text">
              ● Marketing databases<br></br> ● Lead generation<br></br>● Login
              sharing is strictly prohibited<br></br> ● Data resale<br></br> ●
              Third-party sharing
            </p>

            <h3 className="ect-heading">5. Resume Search & Download Policy</h3>
            <p className="ect-text">Employers and authorized staff may:</p>
            <p className="ect-text">
              ● Search candidates by category<br></br>● Filter profiles by
              experience, qualification, and location<br></br>● Download resumes
              individually<br></br>● Impersonate employers, recruiters, or other
              candidates<br></br>● Manipulate platform features or scores
              <br></br>
              <br></br>
              Any misuse will invite legal action, damages, and account
              termination.
            </p>

            <h3 className="ect-heading">6. Acceptable Employer Conduct</h3>
            <p className="ect-text">
              Employers using this pharma job portal must NOT:
            </p>
            <p className="ect-text">
              ● Post fake jobs or misleading vacancies<br></br>● Collect
              candidate data for non-recruitment purposes<br></br>● Harass or
              spam candidates
              <br></br>● Offer illegal or unethical employment
              <br></br>● Misrepresent company identity<br></br>● Conduct
              fraudulent interviews
              <br></br>
              <br></br>
              Strict action, including account termination and legal reporting,
              may be taken for violations.
            </p>

            <h3 className="ect-heading">7. Data Usage Restrictions</h3>
            <p className="ect-text">
              All candidate data available on the platform is protected.
              <br></br>
              <br></br>Employers are strictly prohibited from:<br></br>
              <br></br>● Scraping or copying data
              <br></br>● Using bots or automation tools<br></br>● Building
              databases from profiles
              <br></br>● Selling candidate information<br></br>● Using data for
              AI or machine-learning training
              <br></br>
              <br></br>Unauthorized extraction or misuse may lead to legal
              action and permanent platform ban.
            </p>

            <h3 className="ect-heading">8. Accuracy of Job Listings</h3>
            <p className="ect-text">
              Employers must ensure that all job postings:
              <br></br>
              <br></br>● Represent genuine openings<br></br>● Include correct
              role descriptions<br></br>● Specify accurate qualifications
              <br></br>● Clearly state salary details (if provided)
              <br></br>
              <br></br>The platform is not responsible for disputes arising from
              incorrect job descriptions posted by employers.
            </p>

            <h3 className="ect-heading">
              9. Platform Nature & Liability Disclaimer
            </h3>
            <p className="ect-text">
              PharmaJobsHireLink operates solely as a <b>digital job portal.</b>{" "}
              We:
            </p>
            <p className="ect-text">
              ● Do not participate in recruitment decisions
              <br></br>● Do not screen candidates for employers<br></br>● Do not
              verify every profile detail
              <br></br>● Do not guarantee hiring results
            </p>
            <p className="ect-text">
              Employers must independently verify candidate credentials before
              hiring.
            </p>

            <h3 className="ect-heading">10. Security & Account Protection</h3>
            <p className="ect-text">
              Employers are responsible for:<br></br>
              <br></br>● Candidate data is used to improve job matching,
              visibility, recommendations, and platform performance.Protecting
              login credentials<br></br> ● Preventing unauthorized access
              <br></br> ● Monitoring staff usage<br></br>
              <br></br>
              The platform may use automated fraud detection systems. Suspicious
              activity may trigger verification checks or temporary
              restrictions.
            </p>

            <h3 className="ect-heading">11. App Usage Compliance</h3>
            <p className="ect-text">
              Employers using mobile applications must comply with policies of
              <br></br>
              <br></br>● <b>Google Play Store</b> and
              <br></br>● <b>Apple App Store</b>
              <br></br>
              <br></br>The platform does not collect unnecessary device data and
              uses permissions only for essential job portal functionality.
            </p>

            <h3 className="ect-heading">12. Intellectual Property Rights</h3>
            <p className="ect-text">
              All platform elements including:
              <br></br>
              <br></br>● Software<br></br> ● Interface
              <br></br> ● Design<br></br> ● Databases
              <br></br> ● Content
              <br></br>
              <br></br>
              are the exclusive property of PharmaJobsHireLink.
            </p>
            <p className="ect-text">
              Employers may not reproduce, modify, reverse engineer, copy, or
              distribute any platform component without written permission.
            </p>

            <h3 className="ect-heading">13. Prohibited Technical Activities</h3>
            <p className="ect-text">Employers must not:</p>
            <p className="ect-text">
              ● Attempt to hack or probe platform security<br></br>● Reverse
              engineer system architecture
              <br></br>● Use scraping software
              <br></br>● Mirror or clone the job portal
            </p>
            <p className="ect-text">
              Any such action will result in immediate legal enforcement
            </p>

            <h3 className="ect-heading">14. Suspension & Termination Rights</h3>
            <p className="ect-text">
              The platform may suspend or terminate employer accounts without
              notice if:
            </p>
            <p className="ect-text">
              ● Payment disputes occur<br></br>● Fraud is suspected<br></br>●
              Terms are violated<br></br>● Complaints are received from
              candidates<br></br>
              <br></br>Termination does not entitle employer to refunds.
            </p>

            <h3 className="ect-heading">15. Limitation of Liability</h3>
            <p className="ect-text">
              PharmaJobsHireLink shall not be liable for:
            </p>
            <p className="ect-text">
              ● Hiring losses<br></br>● Candidate performance issues<br></br>●
              Interview no-shows<br></br>● Technical downtime<br></br>● Data
              delays<br></br>
              <br></br>Maximum liability, if any, is limited to the amount paid
              for platform services.
            </p>

            <h3 className="ect-heading">16. Legal Compliance</h3>
            <p className="ect-text">Employers must comply with:</p>
            <p className="ect-text">
              ● Information Technology laws of India
              <br></br>● Employment laws<br></br>● Data protection regulations
              <br></br>● Anti-spam rules<br></br>
              <br></br>Non-compliance may result in civil or criminal liability.
            </p>

            <h3 className="ect-heading">17. Indemnification</h3>
            <p className="ect-text">
              Employers agree to indemnify and hold harmless PharmaJobsHireLink,
              its directors, employees, partners, and affiliates against claims
              arising from:
            </p>
            <p className="ect-text">
              ● Job postings
              <br></br>● Hiring practices<br></br>● Misuse of candidate data
              <br></br>● Legal disputes with candidates
            </p>

            <h3 className="ect-heading">
              18. Jurisdiction & Dispute Resolution
            </h3>
            <p className="ect-text">
              All disputes shall be governed by Indian law and subject to
              jurisdiction of courts located in <b>Nashik.</b>
            </p>
            <p className="ect-text">
              Disputes may first be attempted to be resolved through arbitration
              before legal proceedings.
            </p>

            <h3 className="ect-heading">19. Policy Updates</h3>
            <p className="ect-text">
              PharmaJobsHireLink reserves the right to update these Terms at any
              time without prior notice. Continued use of the pharma job portal
              indicates acceptance of revised terms.
            </p>

            <h3 className="ect-heading">20. Acceptance Declaration</h3>
            <p className="ect-text">
              By registering, paying employer fees, creating staff accounts, or
              downloading resumes, you confirm that:
            </p>
            <p className="ect-text">
              ● You have read these Terms
              <br></br>● You understand all charges are non-refundable
              <br></br>● You agree to use the pharma job portal lawfully
              <br></br>● You accept all rules stated above
            </p>

            <p className="ect-footer-text" style={{ fontWeight: "bold" }}>
              © {new Date().getFullYear()} All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Termscondition;
